import React, { PureComponent } from 'react';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { Datepicker, Input } from '../../common/components';
import PropTypes from 'prop-types';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';

class Report extends PureComponent {
  state = {
    all: {
      dateFrom: moment().startOf('isoWeek').toDate(),
      dateTo: moment().endOf('isoWeek').toDate(),
    },
    filters: {},
  };

  onDateSelect = (key, value) => {
    const { state } = this;

    set(state, key, value);

    this.setState(cloneDeep(state));
  }

  generateReport = async (ev) => {
    const { currentTarget: { id } } = ev;
    const { dateFrom, dateTo } = this.state[id];
    const filters = cloneDeep(this.state.filters);
    const { onGenerateReport } = this.props;
    onGenerateReport(id, dateFrom, dateTo, pickBy(filters, identity));
  }

  onInputFiltersChange = (name, value) => {
    this.setState({
      filters: {
        [name]: value,
      },
    });
  }

  render() {
    const { all } = this.state;
    const { title, filters } = this.props;
    return (
      <div className="col-md-6">
        <div className="card">
          <div className="card-header font-weight-bold">{title}</div>
          <div className="card-body">
            <Datepicker
              selected={all.dateFrom}
              id="all.dateFrom"
              label="Data od"
              maxDate={new Date()}
              onChange={this.onDateSelect}
            />
            <Datepicker
              selected={all.dateTo}
              id="all.dateTo"
              label="Data do"
              maxDate={new Date()}
              onChange={this.onDateSelect}
            />
            <hr />
            {filters.map((filter) => (
              <Input
                key={filter.id}
                id={filter.id}
                label={filter.label}
                value={this.state.filters[filter.id]}
                onChange={this.onInputFiltersChange}
                horizontal
              />
            ))}
            <div
              id="all"
              className="btn btn-outline-primary"
              onClick={this.generateReport}
              onKeyPress={this.generateReport}
              role="button"
              tabIndex="0"
            >
              GENERUJ RAPORT
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Report.defaultProps = {
  filters: []
};

Report.propTypes = {
  title: PropTypes.string.isRequired,
  onGenerateReport: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired, label: PropTypes.string.isRequired })),
};

export default Report;
